<template lang="pug">
  .b-spec-summary(data-testid="spec-summary")
    ._item
      ._label Плановый бюджет
      ._value(data-testid="spec-summary-planned") {{ money(summary.plannedTotal) }}
    ._item
      ._label Сумма для заказчика
      ._value(data-testid="spec-summary-customer-total") {{ money(summary.customerTotal) }}
    ._item
      ._label Отклонение от плана
      ._value(data-testid="spec-summary-plan-deviation" :class="deviationClass") {{ money(summary.planDeviation) }}
    ._item
      ._label Скидки заказчику
      ._value(data-testid="spec-summary-savings") {{ money(summary.savingsTotal) }}
    ._item
      ._label Вознаграждение от поставщиков
      ._value(data-testid="spec-summary-reward") {{ money(summary.rewardTotal) }}
    ._item
      ._label Комиссия с заказчика
      ._value(data-testid="spec-summary-commission") {{ money(summary.commissionTotal) }}
    ._item
      ._label Доход дизайнера с комплектации
      ._value(data-testid="spec-summary-income") {{ money(summary.designerIncome) }}
</template>

<script>
import { money } from '@/utils/spec';

/**
 * Свод по спецификации (ТЗ 6.2, 7.2): закреплённый блок под шапкой. Числа считает страница
 * складыванием вычисляемых полей позиций из ответа сервера — здесь только показ.
 * Сгенерировано Claude.
 */
export default {
  name: 'SpecSummary',
  props: {
    summary: { type: Object, required: true },
  },
  computed: {
    deviationClass() {
      const value = Number(this.summary.planDeviation ?? 0);
      if (value > 0) return 'over';
      if (value < 0) return 'under';
      return null;
    },
  },
  methods: { money },
};
</script>

<style scoped lang="scss">
.spec-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 26px;
  padding: 12px 16px;
  margin-bottom: 14px;
  border-radius: 8px;
  background: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 10;

  &__label {
    font-size: 11px;
    color: var(--color-middle-gray);
  }

  &__value {
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;

    &.over { color: var(--color-red); }
    &.under { color: var(--color-green); }
  }
}
</style>
